import { render, staticRenderFns } from "./SampleChart.vue?vue&type=template&id=4a3c406f&scoped=true&"
import script from "./SampleChart.vue?vue&type=script&lang=js&"
export * from "./SampleChart.vue?vue&type=script&lang=js&"
import style0 from "./SampleChart.vue?vue&type=style&index=0&id=4a3c406f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c406f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
